
<template>
    <Card>
        <template slot="title">
            <Breadcrumb>
                <BreadcrumbItem to="/serviceInfo">服务商管理</BreadcrumbItem>
                <BreadcrumbItem>{{pageType==1?"编辑":"添加"}}</BreadcrumbItem>
            </Breadcrumb>
        </template>
        <a v-if="pageType==1" @click="goto" slot="extra" style="margin-right: 20px;">设置覆盖区域</a>
        <router-link to="/serviceInfo" slot="extra">返回列表</router-link>
         <Form 
         :style="{width:'500px'}"
         ref="formValidate" 
         :model="formValidate" 
         :rules="ruleValidate" 
         :label-width="160">
            <FormItem label="名称" prop="name">
                <Input v-model="formValidate.name" placeholder="请输入名称"/>
            </FormItem>
            <FormItem label="主体信息" prop="businessInfo">
                <Input v-model="formValidate.businessInfo" placeholder="请输入主体信息"/>
            </FormItem>
            <FormItem label="渠道编码" prop="channelCode">
                <Input v-model="formValidate.channelCode" placeholder="请输入渠道编码"/>
            </FormItem>
            <FormItem label="服务商等级">
                <Input v-model="formValidate.dealerLevel" placeholder="请输入服务商等级"/>
            </FormItem>
            <FormItem label="联系人">
                <Input v-model="formValidate.contacTperson" placeholder="请输入联系人"/>
            </FormItem>
            <FormItem label="联系电话" prop="contactMobile">
                <Input v-model="formValidate.contactMobile" placeholder="请输入联系电话"/>
            </FormItem>
            <FormItem label="达能经销商名称">
                <Input v-model="formValidate.elnDealerName" placeholder="请输入达能经销商名称"/>
            </FormItem>
            <FormItem label="达能经销商代码">
                <Input v-model="formValidate.elnDealerCode" placeholder="请输入达能经销商代码"/>
            </FormItem>
            <FormItem label="营业执照号" prop="lecienceCode">
                <Input v-model="formValidate.lecienceCode" placeholder="请输入营业执照号"/>
            </FormItem>
            <FormItem label="营业执照图片" prop="lecienceImgUrl">
                <Upload 
                ref="upload"
                :show-upload-list="false"
                :action="uploadUrl"
                :data="uploadPram"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :on-error="onError"
                :format="['jpg','jpeg','png']"
                :max-size="20480000"
                :headers='{"token": $sessionToken()}'
                >
                    <Button icon="ios-cloud-upload-outline" :loading="uploading">上传图片</Button>
                    <Icon v-if="formValidate.lecienceImgUrl" :size="18" color="green" type="md-checkmark-circle" />
                </Upload>
                <div>仅支持jpg/png，建议尺寸：不超过20M</div>
            </FormItem>
            <FormItem label="营业执照名称" prop="lecienceName">
                <Input v-model="formValidate.lecienceName" placeholder="请输入营业执照名称"/>
            </FormItem>
            <FormItem label="省市级">
                <Select
                    v-model="province"
                    style="width: 40%"
                    @on-change="(code) => selectArea('province', code)"
                >
                    <Option
                    v-for="(item, index) in provinceList"
                    :key="item.areaCode + '_' + index"
                    :value="item.code + '||' + item.areaName"
                    >{{ item.areaName }}</Option
                    >
                </Select>
                <Select
                    v-model="city"
                    style="width: 40%"
                    @on-change="(code) => selectArea('city', code)"
                >
                    <Option
                    v-for="(item, index) in cityList"
                    :key="item.areaCode + '_' + index"
                    :value="item.code + '||' + item.areaName"
                    >{{ item.areaName }}</Option
                    >
                </Select>
            </FormItem>
            <FormItem label="地址">
                <Input v-model="formValidate.addr" placeholder="请输入地址"/>
            </FormItem>
            <FormItem label="GROUP CODE">
                <Input v-model="formValidate.groupCode" placeholder="请输入groupCode"/>
            </FormItem>
            <FormItem label="所属资金商">
                <Input v-model="formValidate.parentCode" placeholder="请输入parentCode"/>
            </FormItem>
            <FormItem label="状态">
                 <RadioGroup v-model="formValidate.status">
                    <Radio label="0">正常</Radio>
                    <Radio label="1">停用</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="备注">
                <Input v-model="formValidate.remark" placeholder="请输入备注"/>
            </FormItem>


            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
                <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
            </FormItem>
        </Form>
    </Card>
</template>
<script>
import axios from 'axios';
    export default {
        data () {
            return {
                code:'',
                pageType:0,
                // provinceList:[],
                // cityList:[],
                provinceList: [],
                province: "",
                cityList: [],
                city: "",
                countyList: [],
                county: "",
                formValidate:{
                    name:'',
                    businessInfo:'',
                    channelCode:'',
                    dealerLevel:'',
                    contacTperson:'',
                    contactMobile:'',
                    elnDealerName:'',
                    elnDealerCode:'',
                    groupCode:'',
                    lecienceCode:'',
                    lecienceImgUrl:'',
                    lecienceName:'',
                    provinceName:'',
                    provinceId:'',
                    cityName:'',
                    cityId:'',
                    addr:'',
                    remark:'',
                    status: '',
                    parentCode: ''
                },
                ruleValidate: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    businessInfo: [
                        { required: true, message: '请输入主体信息', trigger: 'blur' },
                    ],
                    channelCode: [
                        { required: true, message: '请输入渠道编码', trigger: 'blur' },
                    ],
                    lecienceCode: [
                        { required: true, message: '请输入营业执照号', trigger: 'blur' },
                    ],
                    lecienceImgUrl: [
                        { required: true, message: '请上传营业执照图片', trigger: 'blur' },
                    ],
                    lecienceName: [
                        { required: true, message: '请输入营业执照名称', trigger: 'blur' },
                    ],
                    contactMobile: [
                        {
                            type: 'string',
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的电话格式',
                            trigger: 'blur'
                        }
                    ]
                },
                uploadPram:{
                    scene: 'SHOP'
                },
                uploadUrl:'',
                uploading:false,
            }
        },
        created(){
            this.uploadUrl = axios.defaults.baseURL + 'base/file/publicUpload';
            // this.getAreaList();
            this.getArea("provinceList");
            this.getInfo();
        },
        methods:{
            goto(){
                this.$router.push({
                    path: "/merchant/area",
                    query: {
                    code: this.$route.query.code,
                    },
                });
            },
            getAreaList(code){
                this.cityList = [];
                this.formValidate.cityName = '';
                this.formValidate.cityId = '';
                this.$api.areaQuery({code}).then((res) => {
                    if(res.code == '200'){
                        let key = code?'cityList':'provinceList';
                        this[key] = res.data;
                    }
                });
            },
            // 无code为新增；有则更改
            getInfo(){
                let q = this.$route.query;
                if(q.code){
                    let code = q.code;
                    this.code = code;
                    this.pageType=1;
                    this.$api.spQuery({code}).then((res) => {
                        if(res.code == '200'){
                            let d = res.data;
                            // this.getAreaList(d.provinceId);
                            // 处理省市
                            this.province = `${d.provinceId}||${d.provinceName}`;
                            if(this.province){
                                this.city = `${d.cityId}||${d.cityName}`;
                                this.selectArea("province", this.province)
                            }
                            Object.keys(this.formValidate).forEach((key) => {
                                this.formValidate[key] = d[key];
                            });
                        }
                    });
                }
            },
            handleSubmit (name) {
                let d = this.formValidate;
                let data = {
                    stype:1,
                    ...d
                };
                let path = 'spAdd';
                if(this.pageType==1){
                    path = 'spUpdate';
                    data.code = this.code;
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$api[path](data).then((res) => {
                            if(res.code == '200'){
                                this.$Message.success('操作成功');
                                this.$router.replace({ name: 'serviceInfo'});
                            }
                        });
                    }
                })
            },
            handleReset (name) {
                this.formValidate.lecienceImgUrl = '';
                this.$refs[name].resetFields();
            },
            beforeUpload(d){
                let size = d.size;
                let type = d.type;
                if(size > 20480000){
                    this.$Message.error('图片不可大于20M');
                    return false;//停止上传
                }
                if(type != 'image/png' && type != 'image/jpg' && type != 'image/jpeg'){
                    this.$Message.error('仅支持jpg/png');
                    return false;//停止上传
                }
                this.uploading = true;
            },
            onSuccess(response, file, fileList){
                this.uploading = false;
                let data = response.data;
                // fileId
                this.formValidate.lecienceImgUrl = data.url;
            },
            onError(){
                this.formValidate.lecienceImgUrl = '';
                this.uploading = false;
                this.$Message.error('上传失败');
            },
            selectProvince(code){
                this.getAreaList(code);
            },
            selectArea(type, value) {
                const kv = value.split("||");
                if (type === "province") {
                    this.getArea("cityList", kv[0], kv[1]);
                } else if (type === "city") {
                    console.log(this.province, this.city, this.county);
                    const p_kv = this.province.split("||");
                    const c_kv = this.city.split("||");

                    this.formValidate.provinceId = p_kv[0];
                    this.formValidate.provinceName = p_kv[1];
                    this.formValidate.cityId = c_kv[0];
                    this.formValidate.cityName = c_kv[1];
                }
            },
            getArea(target, code = "", label = "") {
                this.$http({
                    url: axios.defaults.baseURL + "base/area/query",
                    method: "GET",
                    params: { code },
                })
                    .then((res) => res.data)
                    .then((data) => {
                    if (data.code == 200) {
                        this.$set(this, target, data.data);
                    } else {
                        console.log(data.message);
                    }
                    })
                    .catch((err) => console.error(err));
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/other/serviceEdit.vue